module.exports = "<p>\r\n  home works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main